<template>
  <div>
    <v-data-table
       class="primary"
       color="primary"
       dense
      :headers="headers"
      :items="tags"
      :items-per-page="30"
      hide-default-header
      hide-default-footer
      disable-pagination
      group-by="point"
    >
  
    </v-data-table>

  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IPointHaystackTag } from '../main';

@Component({
  components: {},
})
export default class SensorInfo extends Vue {

  @Prop({default: [], type: Array }) public bmos_ids!: string[];

  private headers = [{text: 'point', value: 'point'}, {text: 'haystack key', value: 'haystackkey'}, {text: 'haystack value', value: 'haystackvalue'}];

  private tags: Array<IPointHaystackTag> = [];

  // curl -X POST https://carneab4.memset.net/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
  // --data $'ver:"3.0" id:@619265 action:"tags"\nparams\n[]\n'
  public async getTags(bmos_ids: string[]) {

    const self = this;

    self.tags = await self.$store.cache.dispatch('request_haystack_tags', {bmos_ids: bmos_ids});

    if (bmos_ids === null || bmos_ids === undefined || bmos_ids.length < 1) {
      return;
    }
  }

  get sensor_name() {
    return (this.$store.getters.FirstInfo ? this.$store.getters.FirstInfo.sensor_name : '');
  }

  @Watch('bmos_ids')
  private update() {

    this.tags = [];

    if (this.bmos_ids == null || this.bmos_ids === undefined || this.bmos_ids.length === 0) {
      return;
    }

    this.getTags(this.bmos_ids);
  }

  // @Watch('bmos_ids')
  private mounted() {
    this.update();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

::v-deep td {
  color: rgb(255, 255, 255);
}

::v-deep .v-row-group__header td {
  font-size: 16px;
  color: rgb(0, 0, 0);
}

</style>
